import type { PatientProfile } from "api/models/PatientProfile";

export function isUsingActivityTracking(profile: PatientProfile) {
  const ceStructure = profile?.ce_structure;
  return ceStructure === "rtm" || ceStructure === "invited_non_rtm" || ceStructure === "non_rtm";
}
